import fetch from '@/utils/fetch';

// zym.获取出版社连续型出版物年度选择范围 - 新增
export function getSelYearRecordLxdz(params) {
  return fetch({
      url: 'lxdzpress/lxdz/getSelYearRecordLxdz',
      method: "post",
      data: params
  })
}

// zym.获取出版社连续型出版物 
export function getSuccessList(params) {
    return fetch({
        //  url:'Ydnj/Ydnj/getLxPublisherMaterialList',
        //  url:'lxdzpress/lxdz/getLxPublisherMaterialList',
        url: 'lxdzpress/lxdz/getLxPublisherMaterialList',
        method: "post",
        data: params
    })
}

// zym.出版社 - 连续型出版物列表
export function getSuccessTabs(params) {
    return fetch({
        //  url:'Ydnj/Ydnj/getPublicationOrganizationMaterialList',
        //  url:'eavar/lxdz/material/list',
        url: 'lxdzpress/lxdz/material/list',
        method: "post",
        data: params
    })
}


// zym.审核 - 连续型出版物列表
export function getSuccessCheckTabs(params) {
  return fetch({
      //  url:'Ydnj/Ydnj/getPublicationOrganizationMaterialList',
      //  url:'eavar/lxdz/material/list',
      url: 'lxdzpress/lxdz/material/listcheck',
      method: "post",
      data: params
  })

}

// zym.连续型出版物填报表 - 整体提交
export function successTabSubmit(params) {
    return fetch({
        // url: 'Ydnj/Ydnj/sumbitLxdzOrganizationMaterial',
        url: 'lxdzpress/lxdz/submitLxdzOrganizationMaterial',
        method: "post",
        data: params
    })
}

// zym.连续型出版物填报表 - 整体撤回
export function cancelTabSubmit(params) {
    return fetch({
        // url: 'Ydnj/Ydnj/sumbitLxdzOrganizationMaterial',
        url: 'lxdzpress/lxdz/cancelLxdzOrganizationMaterial',
        method: "post",
        data: params
    })
}

// zym.判断是否可以修改数据 - 连续型电子出版物列表
export function getLxdzModifyFlagByOrganization(params) {
  return fetch({
      url: 'lxdzpress/lxdz/getLxdzModifyFlagByOrganization',
      method: "post",
      data: params
  })
}

// zym.判断是否可以修改数据 - 资料清单列表页面
export function getLxdzModifyFlagByOMaterial(params) {
  return fetch({
      url: 'lxdzpress/lxdz/getLxdzModifyFlagByOMaterial',
      method: "post",
      data: params
  })
}

// zym.判断是否可以修改数据 - 资料填报页面
export function getLxdzModifyFlagByPublication(params) {
  return fetch({
      url: 'lxdzpress/lxdz/getLxdzModifyFlagByPublication',
      method: "post",
      data: params
  })
}


/* 连续型出版物核验进度 */
export function successPgress(params) {
    return fetch({
        url: 'Ydnj/Ydnj/getLxdzExaminePage',
        method: "post",
        data: params
    })
}

// zym.(连续电子型)出版物基本信息 code=401
export function ssSave1(params) {
    return fetch({
        //  url:'Ydnj/Ydnj/updateCode401',
        url: 'lxdzpress/lxdz/material/update/401',
        method: "post",
        data: params
    })
}

// zym.连续型电子出版物 - 出版物基本信息表的信息查询
export function ssRead1(params) {
    return fetch({
        //  url:'Ydnj/Ydnj/getCode401',
        //  url:'eavar/material/code/401',        
        url: 'lxdzpress/lxdz/material/code/401',
        method: "post",
        data: params
    })
}

// zym.(连续电子型)出版单位基本信息 code=402
export function ssSave2(params) {
    return fetch({
        //  url:'Ydnj/Ydnj/updateCode402',
        url: 'lxdzpress/lxdz/material/update/402',
        method: "post",
        data: params
    })

}

// zym.连续型电子出版物 - 出版单位基本信息查询
export function ssRead2(params) {
    return fetch({
        //  url:'Ydnj/Ydnj/getCode402',
        //  url:'eavar/material/code/402', 
        url: 'lxdzpress/lxdz/material/code/402',
        method: "post",
        data: params
    })
}

// zym.(连续电子型)经营情况信息 code=403
export function ssSave3(params) {
    return fetch({
        //  url:'Ydnj/Ydnj/updateCode403',
        url: 'lxdzpress/lxdz/material/update/403',
        method: "post",
        data: params
    })
}

// zym.连续型电子出版物 - 经营情况查询
export function ssRead3(params) {
    return fetch({
        //  url:'Ydnj/Ydnj/getCode403',
        //  url:'eavar/material/code/403',
        url: 'lxdzpress/lxdz/material/code/403',
        method: "post",
        data: params
    })

}

// zym.连续型电子出版物 - 人员基本信息
export function ssList4(params) {
    return fetch({
        //  url:'Ydnj/Ydnj/getCode404List',
        // url:'eavar/material/code/404',
        url: 'lxdzpress/lxdz/material/code/404',
        method: "post",
        data: params
    })
}

// zym.连续型电子出版物 - 调查表
export function ssRead5(params) {
  return fetch({
      //  url:'Ydnj/Ydnj/getCode403',
      //  url:'eavar/material/code/403',
      url: 'lxdzpress/lxdz/material/code/405',
      method: "post",
      data: params
  })

}

// zym.连续型电子 - 人员删除
export function ssRemove4(params) {
    return fetch({
        //  url:'Ydnj/Ydnj/deleteCode404',
        url: 'lxdzpress/lxdz/material/delete/404',
        method: "post",
        data: params
    })
}

// zym.人员列表，清除全部
export function ssClean4(params) {
    return fetch({
        //  url:'Ydnj/Ydnj/clearCode404',
        url: 'lxdzpress/lxdz/material/clearCode404',
        method: "post",
        data: params
    })
}

// zym.保存人员基本信息
export function ssSave4(params) {
    return fetch({
        //  url:'Ydnj/Ydnj/updateCode404',
        url: 'lxdzpress/lxdz/material/update/404',
        method: "post",
        data: params
    })
}


// zym.保存调查表
export function ssSave5(params) {
  return fetch({
      //  url:'Ydnj/Ydnj/updateCode404',
      url: 'lxdzpress/lxdz/material/update/405',
      method: "post",
      data: params
  })
}

// zym.人员基本信息列表
export function ssRead4(params) {
    return fetch({
        //  url:'Ydnj/Ydnj/getCode404',
        url: 'lxdzpress/lxdz/material/code/404',
        method: "post",
        data: params
    })
}

// zym.连续出版物表1导入 
export function ssExcel(params) {

    return fetch({
        //  url:'Ydnj/Ydnj/importLxcbCode401',
        url: 'lxdzpress/lxdz/material/importLxdzCode401',
        method: "post",
        data: params
    })

}

/* 导入错误提示 */

export function ssErrors(params) {

    return fetch({
        url: 'Ydnj/Ydnj/exportLog',
        method: "post",
        data: params
    })

}

// zym.连续出版物人员导入
export function pExcel(params) {

    return fetch({
        //  url:'Ydnj/Ydnj/importCode404',
        url: 'lxdzpress/lxdz/material/importLxdzCode404',
        method: "post",
        data: params
    })

}

/* 连续出版物拷贝表 */

export function ssCopyList(params) {
    return fetch({
        //  url:'Ydnj/Ydnj/getSynchroCodeLxList',
        url: 'lxdzpress/lxdz/material/getSynchroCodeLxList',
        method: "post",
        data: params
    })

}


/* 连续出版物拷贝表 */

export function ssCopyAct(params) {
    return fetch({
        // url: 'Ydnj/Ydnj/synchroLxCode',
        url: 'lxdzpress/lxdz/material/synchroLxCode',
        method: "post",
        data: params
    })

}
/*提交申报人信息*/

export function submitDeclare(params) {
    return fetch({
        // url: 'Ydnj/Ydnj/saveLxdzPOrganizationPersonnel',
        url: 'lxdzpress/lxdz/material/saveLxdzPOrganizationPersonnel',
        method: "post",
        data: params
    })
}

export function code401HistoryData(params) {
    return fetch({
        url: 'lxdzpress/lxdz/getCodeHistoryDataLxdz/401',
        method: "post",
        data: params
    })
}

export function code402HistoryData(params) {
    return fetch({
        url: 'lxdzpress/lxdz/getCodeHistoryDataLxdz/402',
        method: "post",
        data: params
    })
}

export function code403HistoryData(params) {
    return fetch({
        url: 'lxdzpress/lxdz/getCodeHistoryDataLxdz/403',
        method: "post",
        data: params
    })
}


// WEBPACK FOOTER //
// ./src/api/pressRole/pressSuccessive.js